<p-confirmDialog></p-confirmDialog>

<div class="card">
  <div class="card-content outings-page">

  <!-- ===== Stat cards (reporting summary) — always shown, zeros when empty ===== -->
  <div class="stats-cards-row">
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ report?.totalOutings ?? 0 }}</span>
        <span class="stats-card-label">Total outings</span>
        <span class="stats-card-sublabel">
          {{ report?.plannedCount ?? 0 }} planned · {{ report?.confirmedCount ?? 0 }} confirmed · {{ report?.completedCount ?? 0 }} completed
        </span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
    </div>

    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ (report?.totalBudget ?? 0) | number:'1.0-0' }}</span>
        <span class="stats-card-label">Total budget</span>
        <span class="stats-card-sublabel">Spent: {{ (report?.totalActualSpend ?? 0) | number:'1.0-0' }}</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-wallet"></i></div>
    </div>

    <div class="stats-card stats-card--warning">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ (report?.participationRate ?? 0) | number:'1.0-1' }}%</span>
        <span class="stats-card-label">Participation rate</span>
        <span class="stats-card-sublabel">Across completed outings</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-users"></i></div>
    </div>

    <div class="stats-card stats-card--success">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ report?.completedCount ?? 0 }}</span>
        <span class="stats-card-label">Completed</span>
        <span class="stats-card-sublabel">{{ report?.cancelledCount ?? 0 }} cancelled</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
    </div>
  </div>

  <!-- Search, Export Excel and "Plan an outing" all live in the main app header
       (driven by PageHeaderSearchActionService), matching the Allocation page. -->

  <!-- ===== Collapsible filter section (toggled by the funnel icon in the main header) ===== -->
  <div class="filter-bar filter-bar-collapsible mb-4"
       [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
    <div class="filter-bar-filters">
      <div class="filter-field">
        <label for="yearFilter" class="filter-label">Year</label>
        <p-select id="yearFilter" [options]="yearOptions" [(ngModel)]="filterYear" (onChange)="onFilterChange()"
                  optionLabel="label" optionValue="value" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
      </div>
      <div class="filter-field">
        <label for="quarterFilter" class="filter-label">Quarter</label>
        <p-select id="quarterFilter" [options]="quarterOptions" [(ngModel)]="filterQuarter" (onChange)="onFilterChange()"
                  optionLabel="label" optionValue="value" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
      </div>
      <div class="filter-field">
        <label for="projectFilter" class="filter-label">Project</label>
        <p-select id="projectFilter" [options]="projectFilterOptions" [(ngModel)]="filterProjectId" (onChange)="onFilterChange()"
                  optionLabel="label" optionValue="value" [filter]="true" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
      </div>
      <div class="filter-field">
        <label for="statusFilter" class="filter-label">Status</label>
        <p-select id="statusFilter" [options]="statusOptions" [(ngModel)]="filterStatus" (onChange)="onFilterChange()"
                  optionLabel="label" optionValue="value" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
      </div>
      <div class="filter-field">
        <label for="serviceGroupFilter" class="filter-label">Service Group</label>
        <p-select id="serviceGroupFilter" [options]="serviceGroupFilterOptions" [(ngModel)]="filterServiceGroupId"
                  (onChange)="onServiceGroupFilterChange()" optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
                  panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
      </div>
    </div>
    <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
      <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
        <i class="pi pi-filter-slash"></i>
      </button>
    </div>
  </div>

  <!-- ===== Table ===== -->
  <p-table [value]="filteredOutings" [loading]="loading"
           [paginator]="filteredOutings.length > 15" [alwaysShowPaginator]="false" [rows]="15"
           [rowsPerPageOptions]="[15, 25, 50]" [showCurrentPageReport]="true"
           currentPageReportTemplate="Showing {first} to {last} of {totalRecords} outings"
           styleClass="p-datatable-sm compact-striped-table resize-handles-visible" [scrollable]="true"
           [resizableColumns]="true" columnResizeMode="expand">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="projectName">Project <p-sortIcon field="projectName" /></th>
        <th pResizableColumn pSortableColumn="eventName">Event <p-sortIcon field="eventName" /></th>
        <th pResizableColumn pSortableColumn="pmName">PM <p-sortIcon field="pmName" /></th>
        <th pResizableColumn pSortableColumn="plannedDate">Date <p-sortIcon field="plannedDate" /></th>
        <!-- Quarter is derived from plannedDate, so sorting by the date gives the
             same order without needing a separate stored field. -->
        <th pResizableColumn pSortableColumn="plannedDate">Quarter <p-sortIcon field="plannedDate" /></th>
        <th pResizableColumn pSortableColumn="status" class="col-status">Status <p-sortIcon field="status" /></th>
        <th pResizableColumn pSortableColumn="budget">Budget <p-sortIcon field="budget" /></th>
        <th pResizableColumn pSortableColumn="actualSpend">Spend <p-sortIcon field="actualSpend" /></th>
        <th pResizableColumn class="col-participants">Participants</th>
        <th class="col-actions">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-o>
      <tr class="row-clickable" (click)="openEdit(o)">
        <td class="cell-ellipsis" [pTooltip]="o.projectName" tooltipPosition="top">
          <div class="cell-strong">{{ o.projectName }}</div>
          <div class="cell-sub" *ngIf="o.projectCode">{{ o.projectCode }}</div>
        </td>
        <td class="cell-ellipsis" [pTooltip]="o.eventName" tooltipPosition="top">{{ o.eventName }}</td>
        <td class="cell-ellipsis" [pTooltip]="o.pmName" tooltipPosition="top">{{ o.pmName }}</td>
        <td>{{ o.plannedDate | date:'mediumDate' }}</td>
        <td>{{ quarterLabel(o) }}</td>
        <td class="col-status"><p-tag [value]="statusLabel(o.status)" [severity]="statusSeverity(o.status)"></p-tag></td>
        <td>{{ o.budget | number:'1.0-0' }}</td>
        <td>{{ o.actualSpend != null ? (o.actualSpend | number:'1.0-0') : '—' }}</td>
        <td class="col-participants">
          <span class="participant-count" [pTooltip]="participantNames(o)" tooltipPosition="top">
            <i class="pi pi-users"></i>
            {{ o.participants.length }}
            <!-- Planning: RSVP replies are the only signal (headcount). Done: show the attendance the
                 PM actually recorded — invited is no longer assumed to mean participated. -->
            <span class="cell-sub" *ngIf="o.status === OutingStatus.Planning">
              ({{ confirmedCount(o) }} replied)
            </span>
            <span class="cell-sub" *ngIf="o.status === OutingStatus.Done">
              ({{ attendedCount(o) }} participated)
            </span>
          </span>
        </td>
        <td class="col-actions" (click)="$event.stopPropagation()">
          <div class="row-actions">
            <p-button *ngIf="o.photosFolderUrl"
                      icon="pi pi-images" [text]="true" severity="secondary" size="small"
                      (onClick)="openPhotos(o)" pTooltip="View photos" />
            <p-button *ngIf="o.status === OutingStatus.Planning"
                      icon="pi pi-check-circle" [text]="true" severity="success" size="small"
                      (onClick)="openComplete(o)" pTooltip="Mark done (record who participated)" />
            <p-button *ngIf="o.status === OutingStatus.Done"
                      icon="pi pi-user-edit" [text]="true" severity="success" size="small"
                      (onClick)="openAttendance(o)" pTooltip="Update attendance" />
            <!-- Manual re-send: the automatic Done email is once-only, so this covers photos
                 uploaded afterwards or a recipient who never received it. -->
            <p-button *ngIf="o.status === OutingStatus.Done"
                      icon="pi pi-envelope" [text]="true" severity="warn" size="small"
                      (onClick)="openEmailDialog(o)" pTooltip="Email photos link to Marketing" />
            <p-button icon="pi pi-pencil" [text]="true" severity="info" size="small"
                      (onClick)="openEdit(o)" pTooltip="Edit" />
            <p-button icon="pi pi-trash" [text]="true" severity="danger" size="small"
                      (onClick)="confirmDelete(o)" pTooltip="Delete" />
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="10" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No outings found</p>
            <p class="empty-description">
              {{ searchText || hasActiveFilters()
                ? 'No results match your search or filters. Try adjusting them.'
                : 'Click "Plan an outing" to add one.' }}
            </p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>

<!-- ===== Add / Edit dialog — shared form-dialog-form system ===== -->
<p-dialog [(visible)]="dialogVisible" [modal]="true"
            [style]="{ width: '48rem', maxWidth: '95vw' }" styleClass="outing-form-dialog"
            [header]="editingId ? 'Edit outing' : 'Plan an outing'" [draggable]="false"
            [dismissableMask]="false" [closeOnEscape]="false" [closable]="true"
            (onHide)="onDialogHide()">
    <div class="form-dialog-form form-dialog-compact">
      <div class="form-dialog-container">
        <!-- Locked-edit banner. The plan (project, date, participants) is history once the outing is
             done, but the post-event fields — participated, actual spend, remarks, photos — stay editable. -->
        <div class="email-notice" *ngIf="lockedEdit">
          <i class="pi pi-lock"></i>
          <span>
            This outing is <strong>done</strong>. The plan is read-only — you can still update
            <strong>who participated</strong>, actual spend, remarks and photos.
          </span>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label for="projectId">Project <span class="required-star">*</span></label>
            <p-select id="projectId" [options]="projectFilterOptions.slice(1)" [(ngModel)]="form.projectId"
                      (onChange)="onProjectChange()" optionLabel="label" optionValue="value" [disabled]="lockedEdit"
                      [filter]="true" placeholder="Select a project" panelStyleClass="filter-dropdown-panel"></p-select>
          </div>
          <div class="field">
            <label for="pmId">PM / organizer</label>
            <p-select id="pmId" [options]="pmOptions" [(ngModel)]="form.pmId" optionLabel="label" optionValue="value"
                      [filter]="true" [disabled]="lockedEdit" placeholder="Defaults to project manager" panelStyleClass="filter-dropdown-panel"></p-select>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <label for="eventName">Outing option <span class="required-star">*</span></label>
            <p-autocomplete id="eventName" [(ngModel)]="form.eventName" [suggestions]="optionSuggestions"
                            (completeMethod)="completeOption($event)" [dropdown]="true" [forceSelection]="false"
                            [completeOnFocus]="false" [showEmptyMessage]="false"
                            [disabled]="lockedEdit" [style]="{ width: '100%' }" styleClass="w-full"
                            panelStyleClass="filter-dropdown-panel"
                            placeholder="Select or type an option (e.g. Lunch Outing)" />
            <small class="field-hint">Pick an existing option or type a new one — it's saved for next time.</small>
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label for="plannedDate">Planned date <span class="required-star">*</span></label>
            <p-datepicker id="plannedDate" [(ngModel)]="form.plannedDate" dateFormat="D, M d, yy" [showIcon]="true"
                          [disabled]="lockedEdit" placeholder="Select date" [showButtonBar]="true" [showOnFocus]="false" />
          </div>
          <div class="field">
            <label for="startTime">Time</label>
            <input pInputText id="startTime" [(ngModel)]="form.startTime" [disabled]="lockedEdit" placeholder="e.g. 12:00 PM" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label for="location">Location</label>
            <p-autocomplete id="location" [(ngModel)]="form.location" [suggestions]="locationSuggestions"
                            (completeMethod)="completeLocation($event)" [dropdown]="true" [forceSelection]="false"
                            [completeOnFocus]="false" [showEmptyMessage]="false"
                            [disabled]="lockedEdit" [style]="{ width: '100%' }" styleClass="w-full"
                            panelStyleClass="filter-dropdown-panel"
                            placeholder="Select or type a location" />
          </div>
          <div class="field">
            <label for="status">Status</label>
            <p-select id="status" [options]="formStatusOptions" [(ngModel)]="form.status" optionLabel="label"
                      optionValue="value" [disabled]="lockedEdit" panelStyleClass="filter-dropdown-panel"></p-select>
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label for="budget">Budget</label>
            <p-inputnumber id="budget" [(ngModel)]="form.budget" mode="decimal" [minFractionDigits]="0"
                           [maxFractionDigits]="2" [min]="0" [disabled]="lockedEdit" placeholder="0" />
          </div>
          <div class="field">
            <label for="actualSpend">Actual spend</label>
            <!-- Deliberately NOT locked on a Done outing: actual spend is a post-event figure, so
                 the outing being done is exactly when the PM fills it in. -->
            <p-inputnumber id="actualSpend" [(ngModel)]="form.actualSpend" mode="decimal" [minFractionDigits]="0"
                           [maxFractionDigits]="2" [min]="0" placeholder="Set after the event" />
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <label for="participants">Invitees <span class="field-hint">(they receive an invitation email)</span></label>
            <p-multiSelect #participantsMs id="participants" [options]="employeeOptions" [(ngModel)]="form.participantIds"
                           optionLabel="label" optionValue="value" [filter]="true" [disabled]="lockedEdit"
                           placeholder="Select who to invite"
                           display="comma" [showToggleAll]="true"
                           selectedItemsLabel="{0} invited"
                           [maxSelectedLabels]="2"
                           [pTooltip]="selectedParticipantNames()" tooltipPosition="top"
                           [scrollHeight]="'240px'" panelStyleClass="outing-inline-panel"></p-multiSelect>
            <small class="field-hint" *ngIf="form.participantIds.length">
              {{ selectedParticipantNames() }}
            </small>
          </div>
        </div>

        <!-- Attendance is only meaningful once the outing is actually Done. While it's still
             Planning there is nothing to record, so the field stays hidden — the PM records
             attendance in the mark-done popup, then corrects it via "Update attendance". -->
        <div class="form-row" *ngIf="editingId && form.status === OutingStatus.Done && form.participantIds.length">
          <div class="field">
            <label for="attended">Participated <span class="field-hint">(who actually turned up)</span></label>
            <p-multiSelect #attendedMs id="attended" [options]="attendedOptions" [(ngModel)]="form.attendedIds"
                           optionLabel="label" optionValue="value" [filter]="true" placeholder="Who actually participated"
                           display="chip" [scrollHeight]="'240px'" panelStyleClass="outing-inline-panel"></p-multiSelect>
          </div>
        </div>

        <!-- Kept visible on a Done outing so notes can still be added after the event. -->
        <div class="form-row">
          <div class="field">
            <label for="remarks">Remarks</label>
            <textarea pInputText id="remarks" [(ngModel)]="form.remarks" rows="2"
                      placeholder="Notes, agenda…" class="p-inputtext"></textarea>
          </div>
        </div>

        <!-- Photos belong to an outing that already happened: the Done email links Marketing to the
             public photos page. Hidden while Planning — there's nothing to upload yet. -->
        <ng-container *ngIf="editingId && form.status === OutingStatus.Done">
          <!-- Photos -->
          <div class="attach-section">
            <div class="attach-head">
              <span class="attach-title"><i class="pi pi-images"></i> Photos ({{ photoAttachments.length }})</span>
              <label class="attach-upload-btn">
                <i class="pi" [class.pi-upload]="!uploadingPhoto" [class.pi-spin]="uploadingPhoto" [class.pi-spinner]="uploadingPhoto"></i>
                Upload photos
                <input type="file" accept="image/*" multiple hidden (change)="onFileSelected($event)" />
              </label>
            </div>
            <div class="photo-grid" *ngIf="photoAttachments.length; else noPhotos">
              <div class="photo-thumb" *ngFor="let p of photoAttachments">
                <a [href]="p.url" target="_blank" rel="noopener" [title]="p.fileName">
                  <img [src]="p.url" [alt]="p.fileName" loading="lazy" />
                </a>
                <button type="button" class="attach-dl" (click)="downloadAttachment(p)" title="Download"><i class="pi pi-download"></i></button>
                <button type="button" class="attach-del" (click)="deleteAttachment(p)" title="Delete"><i class="pi pi-times"></i></button>
              </div>
            </div>
            <ng-template #noPhotos><p class="attach-empty">No photos uploaded yet.</p></ng-template>
          </div>
        </ng-container>

      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="form-dialog-footer-btns">
        <p-button label="Cancel" icon="pi pi-times" (onClick)="dialogVisible = false" severity="secondary" [outlined]="true" />
        <p-button [label]="editingId ? 'Save changes' : 'Create outing'"
                  icon="pi pi-check" [loading]="saving" severity="primary" (onClick)="save()" />
      </div>
    </ng-template>
  </p-dialog>

<!-- ===== Completion popup — mark the outing Done ===== -->
<p-dialog [(visible)]="completeVisible" [modal]="true" [style]="{ width: '38rem' }"
          [header]="completeMode === 'complete' ? 'Mark outing as done' : 'Update attendance'"
          [draggable]="false" [dismissableMask]="true" [closable]="true">
  <div class="form-dialog-form form-dialog-compact" *ngIf="completeTarget">
    <div class="form-dialog-container">
      <p class="complete-intro">
        Who actually participated in <strong>{{ completeTarget.eventName }}</strong>?
        <ng-container *ngIf="completeMode === 'complete'">
          Everyone is ticked by default — untick anyone who didn't turn up.
        </ng-container>
        <ng-container *ngIf="completeMode === 'attendance'">
          Correct the list if you've since learned who really came.
        </ng-container>
      </p>

      <!-- Bulk helpers + live headcount. RSVP is offered as a starting point only, never as the answer. -->
      <div class="attendance-toolbar">
        <div class="attendance-toolbar-actions">
          <button type="button" class="attendance-link-btn" (click)="toggleAllAttendance()">
            <i class="pi" [class.pi-check-square]="!allAttendanceChecked" [class.pi-stop]="allAttendanceChecked"></i>
            {{ allAttendanceChecked ? 'Clear all' : 'Select all' }}
          </button>
          <button type="button" class="attendance-link-btn" (click)="copyRsvpToAttendance()"
                  pTooltip="Tick exactly the people who replied to their RSVP link" tooltipPosition="top">
            <i class="pi pi-envelope"></i> Copy RSVP replies
          </button>
        </div>
        <span class="attendance-count">
          {{ attendedCheckedCount }} of {{ attendanceParticipants.length }} participated
        </span>
      </div>

      <div class="attendance-list" *ngIf="attendanceParticipants.length; else noParticipants">
        <label class="attendance-row" *ngFor="let p of attendanceParticipants">
          <p-checkbox [(ngModel)]="attendanceChecks[p.employeeId]" [binary]="true"
                      [inputId]="'att-' + p.employeeId" />
          <span class="attendance-name">{{ p.employeeName }}</span>
          <span class="attendance-sg">{{ p.serviceGroupName || '—' }}</span>
          <!-- Intent signal, not attendance: shown so the PM can spot no-shows and walk-ins. -->
          <span class="attendance-rsvp" [class.attendance-rsvp--yes]="p.confirmed">
            <i class="pi" [class.pi-check]="p.confirmed" [class.pi-minus]="!p.confirmed"></i>
            {{ p.confirmed ? 'RSVP: yes' : 'no reply' }}
          </span>
        </label>
      </div>
      <ng-template #noParticipants>
        <p class="attendance-empty">No participants were added to this outing.</p>
      </ng-template>

      <div class="email-notice" *ngIf="completeMode === 'complete'">
        <i class="pi pi-send"></i>
        <span>Marking done emails the <strong>Marketing team</strong> a summary with a link to view &amp; download the photos.</span>
      </div>
      <div class="email-notice" *ngIf="completeMode === 'attendance'">
        <i class="pi pi-info-circle"></i>
        <span>Saving attendance sends <strong>no email</strong> — only the participation record is updated.</span>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="completeVisible = false" severity="secondary" [outlined]="true" />
      <p-button [label]="completeMode === 'complete' ? 'Mark done & notify' : 'Save attendance'"
                icon="pi pi-check" [loading]="completing" severity="success" (onClick)="saveComplete()" />
    </div>
  </ng-template>
</p-dialog>

<!-- Email the photos link to Marketing (manual re-send). Shows who receives it and how many photos
     the linked page holds, so an empty gallery is caught before the email goes out. -->
<p-dialog [(visible)]="emailVisible" [modal]="true" [style]="{ width: '32rem' }"
          header="Send photos to Marketing" [draggable]="false" [dismissableMask]="true" [closable]="true">
  <div class="form-dialog-form form-dialog-compact" *ngIf="emailTarget">
    <div class="form-dialog-container">
      <p class="complete-intro">
        <strong>{{ emailTarget.eventName }}</strong> · {{ emailTarget.projectName }}
      </p>

      <div class="email-loading" *ngIf="emailLoadingPreview">
        <i class="pi pi-spin pi-spinner"></i> Loading email details…
      </div>

      <ng-container *ngIf="!emailLoadingPreview && emailPreview">
        <div class="email-detail-grid">
          <span class="email-detail-label">To</span>
          <span class="email-detail-value">
            <ng-container *ngIf="emailPreview.recipients.length; else noRecipients">
              {{ emailPreview.recipients.join(', ') }}
            </ng-container>
            <ng-template #noRecipients>
              <span class="email-detail-warn">No Marketing recipients configured</span>
            </ng-template>
          </span>

          <span class="email-detail-label">Photos</span>
          <span class="email-detail-value">
            {{ emailPreview.photoCount }} in the gallery
          </span>
        </div>

        <!-- An empty gallery is the most common mistake: the recap links Marketing to a blank page. -->
        <div class="email-notice email-notice--warn" *ngIf="emailPreview.photoCount === 0">
          <i class="pi pi-exclamation-triangle"></i>
          <span>
            There are <strong>no photos</strong> yet. Marketing would open an empty page —
            upload photos from the outing's edit view first.
          </span>
        </div>

        <div class="email-notice email-notice--warn" *ngIf="emailPreview.alreadySent">
          <i class="pi pi-history"></i>
          <span>
            The recap was already sent<ng-container *ngIf="emailPreview.lastSentDate">
              on {{ emailPreview.lastSentDate | date:'mediumDate' }}</ng-container>.
            This will send it <strong>again</strong>.
          </span>
        </div>

        <div class="email-notice" *ngIf="!emailPreview.alreadySent">
          <i class="pi pi-send"></i>
          <span>Marketing receives a summary with a link to view &amp; download the photos.</span>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="emailVisible = false" severity="secondary" [outlined]="true" />
      <p-button label="Send email" icon="pi pi-send" [loading]="emailSending"
                [disabled]="emailLoadingPreview || !emailPreview || !emailPreview.recipients.length"
                severity="success" (onClick)="sendMarketingEmail()" />
    </div>
  </ng-template>
</p-dialog>
